export default "__VITE_ASSET__db01c4a9__"